import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ServerService } from 'src/app/services/server.service';
import { ClipBoardService } from 'src/app/services/clipboard.service';

@Component({
  selector: 'app-cancelled-status-modal',
  templateUrl: './cancelled-status-modal.component.html',
  styleUrls: ['./cancelled-status-modal.component.scss']
})
export class CancelledStatusModalComponent implements OnInit {
  allDetails:any;
  btnStatus = false;
  authToken = localStorage.getItem('token')
  text:any;
  constructor(
    private dialogRef: MatDialogRef<CancelledStatusModalComponent>,
    private _serverService:ServerService,
    private clipBoardService:ClipBoardService,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    this.allDetails = this.data;
    const jobMapping = {
      'CreativeJob': 'Creative Job',
      'PreSalesJob': 'Presales Job',
      'MarketingJob': 'Marketing Job'
    };
    
    this.text = jobMapping[this.data.parent] || 'Escalation';
  }
  close() {
    this.dialogRef.close();
}
updateStatus(){
  this.btnStatus = true;
  const formData: FormData = new FormData();
  formData.append("status", "Cancelled");
  formData.append('campaign_id',this.data.campaign_id)
  // let url;
  
  const urlMapping = {
    'CreativeJob': `campaign_module/creative_jobs/${this.data.id}`,
    'PreSalesJob': `campaign_module/pre_sales_jobs/${this.data.id}`,
    'MarketingJob': `campaign_module/marketing_jobs/${this.data.id}`
  };
  
  const url = urlMapping[this.data.parent] || `campaign_module/escalation/${this.data.id}`;
  this._serverService
    .updateEscalationJobDetails(url, formData, this.authToken)
    .subscribe((data) => {
      this.clipBoardService.showMessgeInText(
        "Job Status Marked as Cancelled Successfully",
        "success-snackbar"
      );
      this.dialogRef.close(data);
      this.btnStatus = false;
    },
    error => {
     console.error('Changing of Job Status failed', error);
     this.btnStatus = false;
     // this.showComponentLoader = false;
   });
}
}
